var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 28,
    viewBox: "0 0 19 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 9,
    r: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49986 0.956299C14.6681 0.956299 18.8562 5.14614 18.8562 10.3126C18.8562 14.1876 11.9042 23.6626 9.49986 27.9965C7.19484 23.837 0.143555 13.96 0.143555 10.3126C0.143555 5.14614 4.3334 0.956299 9.49986 0.956299ZM13.6818 9.96023C13.6818 7.65763 11.8037 5.77946 9.49986 5.77946C7.19787 5.77946 5.31971 7.65763 5.31971 9.96023C5.31971 12.2622 7.19787 14.1404 9.49986 14.1404C11.8037 14.1404 13.6818 12.2622 13.6818 9.96023Z",
    fill: "#9D0909"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.3ca088dfd1f039749de5713839c781d3.svg";
export { ForwardRef as ReactComponent };